import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import CvPage from './cv/CvPage';
import CvTimeline from './cv/CvTimeline';
import CvPaper from './cv/CvPaper';
import AdminPage from './admin/AdminPage';
import NotFound from './notfound/NotFound';

// Простой роутинг без react-router; неизвестный адрес -> 404
const ROUTES = {
  '': App,
  '/index.html': App,
  '/cv': CvPage,
  '/cv/timeline': CvTimeline,
  '/cv/paper': CvPaper,
  '/admin': AdminPage,
};

const root = createRoot(document.getElementById('root'));
const path = window.location.pathname.replace(/\/+$/, '');
const Page = ROUTES[path] || NotFound;

root.render(
  <React.StrictMode>
    <Page />
  </React.StrictMode>
);
